import { render } from "./ChatList.vue?vue&type=template&id=68f7afd0&scoped=true"
import script from "./ChatList.vue?vue&type=script&lang=js"
export * from "./ChatList.vue?vue&type=script&lang=js"

import "./ChatList.vue?vue&type=style&index=0&id=68f7afd0&lang=scss&scoped=true"

import exportComponent from "D:\\myGithub\\customer-web-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f7afd0"]])

export default __exports__